export default {"src":"/_next/static/media/Step1.8f7bd55c.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};